export const mepG7Options = ['room-two-exits-water', 'open-paddock', 'dam', 'beach', 'oval', 'other'] as const;

export const mepG7OptionsLabels: Record<(typeof mepG7Options)[number], string> = {
  'room-two-exits-water': 'In a room with two exits and a water supply',
  'open-paddock': 'Open cleared paddock',
  dam: 'Dam',
  beach: 'Beach',
  oval: 'Oval',
  other: 'Other',
} as const;
